<style lang="scss">
.tableForm {
    text-align: center;
    width: 100%;
    .el-form-item__content,
    .el-date-editor.el-input,
    .el-select,
    .el-cascader,
    .el-input {
        width: 290px;
    }
    .fileload {
        margin-left: 150px;
        padding-bottom: 30px;
        .title {
            text-align: left;
            color: #999999;
            margin-left: -30px;
            // background-position-y: 1px;
        }
        .content {
            width: 600px;
        }
        .file-title {
            background-position-y: 1px;
        }
        .upload-demo {
            position: relative;
            left: -30px;
        }
        .el-upload {
            display: block;
            width: 120px;
        }
        .el-upload__input {
            display: none;
        }
        .el-upload-dragger {
            width: 150px;

            height: 90px;
        }
        .el-upload-dragger .el-icon-upload {
            font-size: 30px;
            margin: 10px 0 3px;
        }
        .el-upload-list__item-name {
            display: block;
        }
        .el-upload-list {
            position: absolute;
            width: 470px;
            top: 90px;
            left: -46px;
        }
        .el-upload-list__item {
            display: block;
            float: left;
            width: 200px;
            margin-top: 10px;
            overflow: hidden;
        }
        .el-upload-dragger .el-upload__text {
            font-size: 10px;
        }
        .btn-box {
            margin-top: 30px;
            text-align: center;
        }
        .main-form {
            width: 300px;
            margin: 40px auto 0 auto;
        }
        .el-upload-dragger {
            border: 1px dashed #d9d9d9;
        }
        .el-upload__tip {
            // margin-bottom: 70px;
        }
        .tip {
            color: #d0011b;
            text-align: left;
            word-wrap: break-word;
            display: block;
        }
    }
    .el-form-item__content {
        width: 290px !important;
        margin-left: 0 !important;
    }
    .el-form-item {
        display: flex;
        margin-bottom: 20px;
    }
    .el-radio {
        margin: 0;
    }
    .cert-pic {
        width: 120px;
        height: 120px;
    }
    .imgUpload {
        // margin-left: 150px;
        .title {
            text-align: left;
            color: #999999;
            margin-left: -30px;
            // background-position-y: 1px;
        }
        .ml-30 {
            margin-left: -30px;
        }
        .example-pic-title {
            color: #999999;
            margin-bottom: 10px;
            text-align: left;
        }
        .upload-pic {
            margin-top: 44px;
        }
        .avatar-uploader-icon {
            width: 120px;
            height: 120px;
            line-height: 120px;
        }

        img {
            width: 120px;
            height: 120px;
            content: normal;
        }
    }

    .examplePic {
        margin-right: 74px;
    }
    .imgDialog {
        width: 50vw;
        img {
            width: 50vw;
        }
        .el-dialog__wrapper {
            text-align: center;
        }
        .el-dialog__header {
            padding: 0;
        }
        .el-dialog__body {
            padding: 0;
        }
    }
}
.el-dialog__header {
    text-align: center;
}
.el-dialog__body {
    width: 570px;
    margin: 0 auto;
}
</style>
<template>
    <el-dialog
        title="信息编辑"
        :visible.sync="myResult"
        style="width：800px;"
        :append-to-body="appendToBody"
    >
        <el-form
            ref="ruleTableForm"
            :model="tableRuleForm"
            label-width="180px"
            class="flexbox"
        >
            <div class="tableForm">
                <div
                    v-for="item, index in tableRuleForm.field"
                    :key="index"
                    v-if="displayRule(item)"
                >
                    <el-form-item
                        v-if="item._item_type!='serial_number'&&item._item_type!='sequence'&&item.type!=6&&item.type!=5"
                        :label="item.name + '：'"
                        :prop="'field.'+index+'.value'"
                        :rules="getRules(item)"
                    >
                        <!--文本框-->
                        <el-tooltip
                            effect="dark"
                            placement="right"
                            :disabled="item.tip==''"
                        >
                            <div
                                slot="content"
                                v-html="item.tip"
                            ></div>

                            <el-input
                                v-if="item.type == 1&&item._item_type!='mobile_num'&&item._item_type!='email'"
                                v-model="item.value"
                                :maxlength="256"
                                :placeholder="'请输入'+item.name+'信息'"
                                @input="getPinYIn(item)"
                                :disabled="item.fixed==''"
                            ></el-input>
                            <!-- 处理后台手机和邮箱加密 -->
                            <el-input
                                v-if="item.type == 1&&(item._item_type=='mobile_num'||item._item_type=='email')"
                                v-model="item.value"
                                :maxlength="256"
                                :placeholder="'请输入'+item.name+'信息'"
                                @change="handleEncryption(item)"
                                :disabled="item.fixed==''||item.is_readonly"
                            ></el-input>
                            <!--单选框（选项个数<=2）-->
                            <el-radio-group
                                v-if="item.type == 2 && item.sub_confs.length<=2"
                                v-model="item.value"
                            >
                                <el-radio
                                    :label="subItem.value"
                                    v-for="subItem in item.sub_confs"
                                    :key="subItem.value"
                                    :disabled="item.fixed==''"
                                >{{subItem.value}}</el-radio>
                            </el-radio-group>
                            <!--单选框（选项个数>2）-->
                            <el-select
                                v-if="item.type == 2 && item.sub_confs.length>2"
                                v-model="item.value"
                                :clearable="!item.is_required"
                                :filterable="true"
                                placeholder="请选择"
                                :disabled="item.fixed==''"
                            >
                                <el-option
                                    v-for="subItem in item.sub_confs"
                                    :key="subItem.value"
                                    :label="subItem.value"
                                    :value="subItem.value"
                                ></el-option>
                            </el-select>
                            <!--多选框-->
                            <el-select
                                v-if="item.type == 3"
                                v-model="item.value"
                                multiple
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="subItem in item.sub_confs"
                                    :key="subItem.value"
                                    :label="subItem.value"
                                    :value="subItem.value"
                                ></el-option>
                            </el-select>
                            <!--日期选择-->
                            <el-date-picker
                                v-if="item.type == 4"
                                v-model="item.value"
                                :picker-options="DateOpt"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                :clearable="!item.is_required"
                                type="date"
                                :editable="false"
                                :default-value="setDefaultTime(item.sub_confs)"
                                @focus="setDateLimit(item)"
                                placeholder="选择日期"
                            ></el-date-picker>
                            <!--级联选择-->
                            <el-cascader
                                v-if="item.type == 7"
                                :options="item.sub_confs"
                                filterable
                                v-model="item.value"
                            ></el-cascader>
                        </el-tooltip>
                    </el-form-item>
                    <el-form-item
                        v-if='item.type==6'
                        class="imgUpload"
                    >

                        <div class="title img-bot">
                            <span class="iconfont icon-picture"></span>
                            <span class="AEE-tc">{{item.name}}</span>
                            <span class="fS12">（图片小于1M，仅支持{{computerNumber(item.sub_confs[0].support_types, 1)}}格式）</span>
                            <span
                                class="fS12"
                                v-if="item.sub_confs[0].pic_size"
                            >尺寸要求：{{item.sub_confs[0].pic_size}}</span>
                        </div>
                        <div
                            class="example-pic-title"
                            v-if="item.sub_confs[0].sample_links[0]"
                        >样例照片</div>
                        <div
                            v-if="item.sub_confs[0].sample_links[0]"
                            class="float-left examplePic ml-30"
                        >
                            <!-- <div class="example-pic-title">样例照片</div> -->
                            <!-- @click="dialogDisplay(example_pic[(fieldImg.indexOf(item))].url)" -->

                            <img
                                :src="example_pic[(fieldImg.indexOf(item))].url"
                                class="cert-pic"
                            />
                        </div>
                        <div class="float-left mT30 ml-30">
                            <el-upload
                                :http-request="uploadImg"
                                :data="{item:item,callback:uploadCallback}"
                                class="avatar-uploader mT30"
                                action="#"
                                :accept="computerNumber(item.sub_confs[0].support_types, 2)"
                                :show-file-list="false"
                                :before-upload="beforeAvatarUpload"
                            >
                                <img
                                    v-if="item.value"
                                    :src="upload_img[(fieldImg.indexOf(item))].url"
                                    class="avatar"
                                />
                                <i
                                    v-else
                                    class="el-icon-plus avatar-uploader-icon"
                                ></i>
                            </el-upload>
                        </div>

                        <div class="clear"></div>
                        <div
                            class="tip"
                            v-html="setTip(item.tip)"
                        ></div>

                    </el-form-item>

                </div>

                <div
                    v-for="itm in fieldFile"
                    v-if="itm.is_pass"
                    class="fileload el-form-item"
                >
                    <div class="content">
                        <div>
                            <div class="title file-title file-bot">
                                <span class="AEE-tc">{{itm.name}}</span>
                                <span class="fS12"> (文件大小≤5M，

                                    <span
                                        class="fS12"
                                        v-if="itm.sub_confs[0].support_types!==1"
                                    >只能上传{{computerNumberFile(itm.sub_confs[0].support_types, 1)}}文件</span>
                                    <span
                                        class="fS12"
                                        v-else
                                    >不限制文件格式</span>)，
                                    上传文件数量≤{{itm.sub_confs[0].upper_limit}})</span>
                                <span class="tip">{{setTip(itm.tip)}}</span>
                            </div>

                            <!-- <div
                                class="el-upload__tip tip"
                                v-html=""
                            >
                            </div> -->
                            <el-upload
                                class="upload-demo"
                                drag
                                :on-exceed="handleExceed"
                                :on-change="handleChange"
                                :http-request="uploadFile"
                                :data="{item:itm,callback:uploadCallbackFile}"
                                action="#"
                                :file-list="fileList[fieldFile.indexOf(itm)]"
                                :on-remove="removeFile"
                                :limit="itm.sub_confs[0].upper_limit"
                                :accept="computerNumberFile(itm.sub_confs[0].support_types, 2)"
                                multiple
                                :before-upload="beforeAvatarUploadFile"
                            >
                                <i class="el-icon-upload AEE-tc"></i>

                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>

                            </el-upload>
                        </div>
                    </div>
                </div>
                <el-button
                    type="primary"
                    :class="btnClass"
                    @click="formSubmit"
                >{{btnName=="add"?"添加":"修改"}}</el-button>
            </div>
            <el-dialog
                :visible.sync="dialogVisible"
                custom-class="hidden-xs hidden-sm imgDialog"
            >
                <img :src="dialogImageUrl" />
            </el-dialog>
        </el-form>
    </el-dialog>
</template>
<script type="text/ecmascript-6">
import "../../assets/js/pinyinUtil";
export default {
    data() {
        var validateChecked = (rule, value, callback) => {
            if (value == "") {
                callback(new Error("请再核对信息并上传正确的照片"));
            } else {
                callback();
            }
        };
        return {
            DateOpt: {
                disabledDate: time => {
                    let isDate = new Date(
                        this.$common.formatDate(time, "yyyy-MM-dd")
                    );
                    if (this.dateLimit.begin_datetime) {
                        if (this.dateLimit.end_datetime) {
                            return (
                                isDate.getTime() >
                                    new Date(
                                        this.dateLimit.end_datetime
                                    ).getTime() ||
                                isDate.getTime() <
                                    new Date(
                                        this.dateLimit.begin_datetime
                                    ).getTime()
                            );
                        }
                        return (
                            isDate.getTime() <
                            new Date(this.dateLimit.begin_datetime).getTime()
                        );
                    }
                    if (this.dateLimit.end_datetime) {
                        return (
                            isDate.getTime() >
                            new Date(this.dateLimit.end_datetime).getTime()
                        );
                    }
                }
            },
            validCardId: (rule, value, callback) => {
                var cardType = null;
                this.tableRuleForm.field.forEach(item => {
                    if (item._item_type == "cert_type") {
                        cardType = item.value;
                    }
                });
                if (cardType == "居民身份证") {
                    if (!this.$common.validateChinaCt(value)) {
                        callback(new Error("证件号码不正确"));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            },
            validZipCode: (rule, value, callback) => {
                var re = /^[0-9]{6}$/;
                if (re.test(value)) {
                    callback();
                } else {
                    callback(new Error("邮政编码不正确"));
                }
            },
            validMobileNum: (rule, value, callback) => {
                if (value != "") {
                    if (this.isMobileChange) {
                        if (this.$common.validMobileNum(value)) {
                            callback();
                        } else {
                            callback(new Error("手机号不正确"));
                        }
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            },
            validEmail: (rule, value, callback) => {
                if (value != "") {
                    if (this.isEmailChange) {
                        if (this.$common.validEmail(value)) {
                            callback();
                        } else {
                            callback(new Error("邮箱号不正确"));
                        }
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            },
            dialogVisible: false,
            example_pic: [],
            upload_img: [],
            proc_id: "",
            dialogImageUrl: "",
            fieldImg: [],
            fieldFile: [],
            fileList: [],
            tempFileType: [],
            myResult: this.ruleFormDialogVisible,
            validResultImg: false,
            validResultFile: false,
            isMobileChange: false,
            isEmailChange: false,
            rules: {
                name: [
                    { required: true, message: "请输入姓名", trigger: "blur" }
                ],
                sex: [
                    { required: true, message: "请选择性别", trigger: "change" }
                ],
                birth_date: [
                    {
                        type: "date",
                        required: true,
                        message: "请选择出生年月",
                        trigger: "change"
                    }
                ],
                checked: [
                    {
                        required: true,
                        validator: validateChecked,
                        trigger: "change"
                    }
                ]
            }
        };
    },
    props: {
        tableRuleForm: {
            type: Object,
            default: function() {
                return {
                    field: []
                };
            }
        },
        btnName: {
            type: String,
            default: "add"
        },
        ruleFormDialogVisible: {
            type: Boolean,
            default: false
        },
        appendToBody: {
            type: Boolean,
            default: false
        },
        btnClass: {
            type: String,
            default: ""
        }
    },
    created: function() {
        this.$set(this.tableRuleForm);

        this.getData();
    },
    watch: {
        tableRuleForm: {
            immediate: true,
            handler(val) {}
        },
        btnName(val) {
            if (val == "add") {
                // this.fileList = [];
                this.upload_img = [];
                this.fieldImg = [];
                this.$refs["ruleTableForm"].resetFields();
            }
        },
        ruleFormDialogVisible(val) {
            this.myResult = val;
            if (val) {
                this.getData();
            }
        },
        myResult(val) {
            if (!val) {
                this.fileList = [];
                // this.$refs["ruleTableForm"].resetFields();
            }
            this.$emit("on-result-change", val);
        }
    },
    methods: {
        handleEncryption(item) {
            if (item._item_type == "mobile_num") {
                this.isMobileChange = true;
            } else if (item._item_type == "email") {
                this.isEmailChange = true;
            }
        },
        beforeAvatarUploadFile(file) {
            const isLt1M = file.size / 1024 / 1024 <= 5;
            const isJPG =
                file.type === "application/vnd.ms-powerpoint" ||
                file.type === "application/vnd.ms-excel" ||
                file.type ===
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
                file.type ===
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/pdf";
            if (!isJPG) {
                this.$alert("请上传正确格式的文件", {
                    confirmButtonText: "确定"
                });
                return false;
            }
            if (!isLt1M) {
                this.$alert("文件过大，请上传5M以内的文件", {
                    confirmButtonText: "确定"
                });
                return false;
            }
            return true;
        },
        checkDataFile: function(callback) {
            this.validResultFile = true;
            this.fieldFile.forEach((item, index) => {
                if (item.is_pass) {
                    if (item.is_required) {
                        if (this.fileList[index].length == 0) {
                            this.validResultFile = false;
                            return;
                        }
                    }
                }
            });
            callback && callback();
        },
        removeFile(file, fileList) {
            this.$http
                .post(globalProvider.serviceUrl("oss/_f/d/lk/single"), {
                    file_guid: file.file_id
                })
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        for (let item of this.fileList) {
                            if (item.indexOf(file) > -1) {
                                let index = this.fileList.indexOf(item);
                                this.fileList[index].splice(
                                    item.indexOf(file),
                                    1
                                );
                            }
                        }
                    }
                });
        },
        getFileUrl: function(proc_id, id) {
            if (proc_id != null) {
                this.$http
                    .get(
                        globalProvider.serviceUrl("oss/_f/g/lk/dl/{proc_id}"),
                        { params: { proc_id: proc_id, loading: true } }
                    )
                    .then(data => {
                        if (data.body.code == resultCode.Success) {
                            for (let item of data.body.data) {
                                this.fileList[id].push({
                                    file_id: item.file_guid,
                                    name: item.name
                                });
                            }
                        } else if (data.body.code == resultCode.NotSuccess) {
                            this.$alert(getErrorMessage(data.body.message));
                        }
                    });
            }
        },
        handleExceed() {
            this.$alert("超出文件数量");
        },
        handleChange(file, fileList) {
            this.tempFileType = fileList;
        },
        uploadFile: function(_upload) {
            let type = this.computerNumberFile(
                _upload.data.item.sub_confs[0].support_types,
                2
            );
            if (type.indexOf(_upload.file.type) == -1) {
                this.$alert("请上传正确格式的文件", {
                    confirmButtonText: "确定"
                });
                this.tempFileType.pop();
            } else {
                _upload.data.callback(_upload);
            }
        },
        uploadCallbackFile: function(_upload) {
            let index = this.fieldFile.indexOf(_upload.data.item);
            this.$http
                .post(globalProvider.serviceUrl("oss/_f/g/lk/up/pc"), {
                    proc_id: _upload.data.item.value,
                    file_name: _upload.file.name,
                    type: _upload.file.type
                })
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        let uploadUrl = data.body.data.link;
                        this.fieldFile[index].value = data.body.data.proc_id;
                        let file_id = data.body.data.file_guid;
                        this.$http
                            .put(uploadUrl, _upload.file, {
                                headers: {
                                    "Content-Type": _upload.file.type,
                                    "Content-Disposition":
                                        "attachment;filename=" +
                                        encodeURI(_upload.file.name)
                                }
                            })
                            .then(response => {
                                if (response.status == 200) {
                                    _upload.onSuccess(1);
                                    if (
                                        this.fileList[index].length <=
                                        _upload.data.item.sub_confs[0]
                                            .upper_limit
                                    ) {
                                        this.fileList[index].push({
                                            name: _upload.file.name,
                                            file_id: file_id
                                        });
                                    }
                                } else {
                                    _upload.onError(1);
                                }
                            });
                    } else if (data.body.code == resultCode.NotSuccess) {
                        _upload.onError(1);
                        this.$alert(getErrorMessage(data.body.message));
                    }
                });
        },
        getData: function() {
            this.fieldImg = [];
            this.fieldFile.length = 0;
            this.fileList = [];
            const uuidv1 = require("uuid/v1");
            if (this.btnName == "add") {
                this.upload_img = [];
                this.fieldImg = [];
            }
            this.tableRuleForm.field.forEach(item => {
                if (item.type == 6) {
                    this.fieldImg.push(item);
                }
                if (item.type == 5) {
                    this.fieldFile.push(item);
                }
            });

            let passLength2 = 0;
            for (let item of this.fieldFile) {
                this.displayRule(item);
                if (item.is_pass) {
                    passLength2++;
                }
                this.fileList.push([]);
                if (item.value) {
                    this.getFileUrl(item.value, this.fieldFile.indexOf(item));
                } else {
                    item.value = uuidv1();
                }
            }
            let passLength = 0;
            for (let item of this.fieldImg) {
                this.displayRule(item);
                if (item.is_pass) {
                    passLength++;
                }
                this.example_pic.push({
                    url: ""
                });
                this.upload_img.push({
                    url: ""
                });
                if (item.sub_confs[0].sample_links[0]) {
                    this.getImgUrl(
                        item.sub_confs[0].sample_links[0],
                        this.fieldImg.indexOf(item),
                        1
                    );
                }
                if (item.value) {
                    this.getImgUrl(item.value, this.fieldImg.indexOf(item), 2);
                }
                if (item._item_type === "cert_pic") {
                    this.cert_pic = item;
                    this.cert_pic_have = true;
                }
            }
        },
        checkData: function(callback) {
            this.validResultImg = true;
            this.fieldImg.forEach(item => {
                if (item.is_pass) {
                    if (item.is_required) {
                        if (
                            (item.value instanceof Array &&
                                item.value.length == 0) ||
                            !item.value
                        ) {
                            this.validResultImg = false;
                            return;
                        }
                    }
                }
            });
            callback && callback();
        },
        formSubmit: function() {
            this.$refs["ruleTableForm"].validate(valid => {
                if (valid) {
                    this.checkData(() => {
                        if (this.validResultImg) {
                            this.checkDataFile(() => {
                                if (this.validResultFile) {
                                    let formData = [];
                                    this.tableRuleForm.field.forEach(item => {
                                        if (item.is_pass) {
                                            if (item.type == 4) {
                                                formData.push({
                                                    name: item.name,
                                                    value: item.value,
                                                    type: item.type,
                                                    _item_type: item._item_type,
                                                    tag: item.tag,
                                                    is_required:
                                                        item.is_required
                                                });
                                            } else if (item.type == 7) {
                                                formData.push({
                                                    name: item.name,
                                                    value:
                                                        item.value.length == 0
                                                            ? item.value.length
                                                            : item.value[
                                                                  item.value
                                                                      .length -
                                                                      1
                                                              ],
                                                    type: item.type,
                                                    _item_type: item._item_type,
                                                    tag: item.tag,
                                                    is_required:
                                                        item.is_required
                                                });
                                            } else if (
                                                item.type == 1 &&
                                                item.sub_confs.enable_pinyin
                                            ) {
                                                formData.push({
                                                    name: item.name,
                                                    value: item.value,
                                                    py_value: item.py_value,
                                                    type: item.type,
                                                    _item_type: item._item_type,
                                                    tag: item.tag,
                                                    is_required:
                                                        item.is_required
                                                });
                                            } else {
                                                formData.push({
                                                    name: item.name,
                                                    value: item.value,
                                                    type: item.type,
                                                    _item_type: item._item_type,
                                                    tag: item.tag,
                                                    is_required:
                                                        item.is_required
                                                });
                                            }
                                        }
                                    });
                                    let tableData = {};
                                    formData.forEach((item, idx, arr) => {
                                        if (item.type == 6 || item.type == 5) {
                                            tableData[item.tag] = {
                                                proc_id: item.value
                                            };
                                        } else {
                                            tableData[item.tag] = item.value;
                                        }
                                    });
                                    this.$emit("handleFormSubmit", tableData);
                                    this.$refs["ruleTableForm"].resetFields();
                                } else {
                                    this.btnDisable = false;
                                    this.$alert("请上传所有文件", {
                                        confirmButtonText: "确定"
                                    });
                                }
                            });
                        } else {
                            this.btnDisable = false;
                            this.$alert("请上传所有图片", {
                                confirmButtonText: "确定"
                            });
                        }
                    });
                } else {
                }
            });
        },
        getPinYIn: function(item) {
            if (item.sub_confs.enable_pinyin) {
                var n = pinyinUtil.getPinyin(item.value).toUpperCase();
                var j,
                    num = 0;
                if (n) {
                    for (let i of n.split(" ")) {
                        if (n.indexOf(i) == 0 && num == 0) {
                            num++;
                            j = i + " ";
                        } else {
                            j = j + i;
                        }
                    }
                }
                item.py_value = j;
            }
        },
        displayRule(item) {
            if (item.rules != null && item.rules.length > 0) {
                for (let i of item.rules) {
                    for (let j of this.tableRuleForm.field) {
                        if (j.tag == i.tag) {
                            if (displayRuleType[i.condition]) {
                                if (j.type == 3) {
                                    let states = true;
                                    for (let option of i.value) {
                                        if (j.value.indexOf(option) == -1) {
                                            states = false;
                                        }
                                    }
                                    if (!states) {
                                        item.value = "";
                                        item.is_pass = false;
                                        return false;
                                    }
                                } else {
                                    if (i.value.indexOf(j.value) == -1) {
                                        item.value = "";
                                        item.is_pass = false;
                                        return false;
                                    }
                                }
                            } else {
                                if (!j.value) {
                                    item.value = "";
                                    item.is_pass = false;
                                    return false;
                                }
                            }
                        }
                    }
                }
                item.is_pass = true;
                return true;
            } else {
                item.is_pass = true;
                return true;
            }
        },
        changePy(item) {
            item.py_value = item.py_value.toUpperCase();
            this.tableRuleForm.field.splice(
                this.tableRuleForm.field.indexOf(item),
                1,
                item
            );
        },
        getRules: function(item) {
            // 证件号码验证，仅当证件类型为居民身份证时验证格式
            if (item.type == 1 && item._item_type == "cert_id") {
                if (item.is_required) {
                    return [
                        {
                            required: true,
                            message: item.name + "不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: this.validCardId,
                            trigger: "blur"
                        }
                    ];
                } else {
                    return [
                        {
                            validator: this.validCardId,
                            trigger: "blur"
                        }
                    ];
                }
            }
            if (
                item.type == 1 &&
                item._item_type == "zip_code" &&
                item.is_required
            ) {
                if (item.is_required) {
                    return [
                        {
                            required: true,
                            message: item.name + "不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: this.validZipCode,
                            trigger: "blur"
                        }
                    ];
                } else {
                    return [
                        {
                            validator: this.validZipCode,
                            trigger: "blur"
                        }
                    ];
                }
            }
            if (item.type == 1 && item._item_type == "mobile_num") {
                if (item.is_required) {
                    return [
                        {
                            required: true,
                            message: item.name + "不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: this.validMobileNum,
                            trigger: "blur"
                        }
                    ];
                } else {
                    return [
                        {
                            validator: this.validMobileNum,
                            trigger: "blur"
                        }
                    ];
                }
            }
            if (item.type == 1 && item._item_type == "email") {
                if (item.is_required) {
                    return [
                        {
                            required: true,
                            message: item.name + "不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: this.validEmail,
                            trigger: "blur"
                        }
                    ];
                } else {
                    return [
                        {
                            validator: this.validEmail,
                            trigger: "blur"
                        }
                    ];
                }
            }
            // 下面4种为标准表单验证
            if (item.type == 1 && item.is_required) {
                return {
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "blur"
                };
            } else if (item.type == 2 && item.is_required) {
                return {
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "change"
                };
            } else if (item.type == 3 && item.is_required) {
                return {
                    type: "array",
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "change"
                };
            } else if (item.type == 4 && item.is_required) {
                return {
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "change"
                };
            } else if (item.type == 7 && item.is_required) {
                return {
                    type: "array",
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "change"
                };
            }
        },
        setDefaultTime: function(item) {
            let d1 = new Date(item.begin_datetime);
            let d2 = new Date(item.end_datetime);
            if (item.begin_datetime && item.end_datetime) {
                let d3 = new Date((d2.getTime() + d1.getTime()) / 2);
                return d3;
            } else if (item.begin_datetime) {
                let d3 = new Date(d1.getTime() + 3600000 * 24);
                return d3;
            } else if (item.end_datetime) {
                let d3 = new Date(d2.getTime() - 3600000 * 24);
                return d3;
            } else {
                return "";
            }
        },
        getPinyinRules: function(item) {
            if (item.type == 1 && item.sub_confs.enable_pinyin) {
                return {
                    required: true,
                    message: item.name + "拼音不能为空",
                    trigger: "blur"
                };
            }
        },
        setDateLimit: function(item) {
            this.dateLimit = item.sub_confs;
        },
        //上传图片
        dialogDisplay(url) {
            this.dialogImageUrl = url;
            this.dialogVisible = true;
        },
        setTip(tip) {
            if (tip) {
                return tip.replace("\n", "<br>");
            } else {
                return "";
            }
        },
        computerNumberFile(num, type) {
            let Node = {
                No_Restrict: "1",
                PDF: "2",
                Word: "4",
                PPT: "8",
                JPG: "16",
                PNG: "32",
                Excel: "64"
            };
            let contentType = {
                No_Restrict: "",
                PDF: "application/pdf",
                Word:
                    "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                PPT:
                    "application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation",
                Excel: "application/vnd.ms-excel"
            };
            let format = [];
            for (let item in Node) {
                if ((num & Node[item]) == parseInt(Node[item])) {
                    format.push(item);
                }
            }
            if (type === 1) {
                let string = "";
                for (let i in format) {
                    if (i == format.length - 1) {
                        string = string + format[i];
                    } else {
                        string = string + format[i] + ",";
                    }
                }
                return string;
            } else {
                let string = "";
                for (let i in format) {
                    if (i == format.length - 1) {
                        string = string + contentType[format[i]];
                    } else {
                        string = string + contentType[format[i]] + ",";
                    }
                }
                return string;
            }
        },
        computerNumber(num, type) {
            let Node = {
                No_Restrict: "1",
                PDF: "2",
                Word: "4",
                PPT: "8",
                JPG: "16",
                PNG: "32"
            };
            let format = [];
            for (let item in Node) {
                if ((num & Node[item]) == parseInt(Node[item])) {
                    format.push(item);
                }
            }
            if (type === 1) {
                let string = "";
                for (let i in format) {
                    if (i == format.length - 1) {
                        string = string + format[i];
                    } else {
                        string = string + format[i] + ",";
                    }
                }
                return string;
            } else {
                let string = "";
                for (let i in format) {
                    if (i == format.length - 1) {
                        if (format[i] === "JPG") string = string + "image/jpeg";
                        if (format[i] === "PNG") string = string + "image/png";
                    } else {
                        string = string + "image/jpeg" + ", ";
                    }
                }
                return string;
            }
        },
        beforeAvatarUpload(file) {
            const isLt1M = file.size / 1024 / 1024 <= 1;
            const isJPG =
                file.type === "image/jpeg" || file.type === "image/png";
            if (!isJPG) {
                this.$alert("请上传正确格式的图片", {
                    confirmButtonText: "确定"
                });
                return false;
            }
            if (!isLt1M) {
                this.$alert("图片过大，请上传1M以内的图片", {
                    confirmButtonText: "确定"
                });
                return false;
            }
            return true;
        },
        uploadImg: function(_upload) {
            let vm = this;
            var _URL = window.URL || window.webkitURL;
            let img = new Image();
            let type = this.computerNumber(
                _upload.data.item.sub_confs[0].support_types,
                2
            );
            if (type.indexOf(_upload.file.type) != -1) {
                img.onload = function() {
                    let limit_size = _upload.data.item.sub_confs[0].pic_size;
                    if (limit_size) {
                        if (
                            limit_size.split("*")[0] == this.width &&
                            limit_size.split("*")[1] == this.height
                        ) {
                            _upload.data.callback(_upload);
                        } else {
                            vm.$alert(
                                "图片尺寸错误，请上传" +
                                    limit_size +
                                    "大小的图片",
                                {
                                    confirmButtonText: "确定"
                                }
                            );
                        }
                    } else {
                        _upload.data.callback(_upload);
                    }
                };
                img.src = _URL.createObjectURL(_upload.file);
            } else {
                this.$alert("请上传正确格式的图片", {
                    confirmButtonText: "确定"
                });
            }
        },
        uploadCallback: function(_upload) {
            let index;
            index = this.fieldImg.indexOf(_upload.data.item);
            // if (index < 0) index = 0;
            this.$http
                .post(globalProvider.serviceUrl("oss/_f/g/lk/up/pc"), {
                    proc_id: _upload.data.item.value,
                    file_guid: this.upload_img[index].file_guid,
                    file_name: _upload.file.name,
                    type: _upload.file.type
                })
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        this.btnDisable = false;
                        this.proc_id = data.body.data.proc_id;
                        let uploadUrl = data.body.data.link;
                        this.fieldImg[index].value = data.body.data.proc_id;
                        this.$http
                            .put(uploadUrl, _upload.file, {
                                headers: {
                                    "Content-Type": _upload.file.type,
                                    "Content-Disposition":
                                        "attachment;filename=" +
                                        encodeURI(_upload.file.name)
                                }
                            })
                            .then(response => {
                                if (response.status == 200) {
                                    this.getImgUrl(
                                        this.fieldImg[index].value,
                                        index,
                                        2
                                    );
                                } else if (
                                    data.body.code == resultCode.NotSuccess
                                ) {
                                    this.upload_img[index].file_guid = "";
                                    this.$alert(
                                        getErrorMessage(data.body.message)
                                    );
                                }
                            });
                    }
                });
        },
        getImgUrl: function(proc_id, id, place) {
            if (proc_id != null) {
                this.$http
                    .get(
                        globalProvider.serviceUrl("oss/_f/g/lk/dl/{proc_id}"),
                        {
                            params: {
                                proc_id: proc_id,
                                loading: true
                            }
                        }
                    )
                    .then(data => {
                        if (data.body.code == resultCode.Success) {
                            if (place == 1) {
                                this.example_pic[id].url =
                                    data.body.data[0].link;
                            }
                            if (place == 2) {
                                this.upload_img[id].url =
                                    data.body.data[0].link;
                                this.upload_img[id].file_guid =
                                    data.body.data[0].file_guid;
                            }
                        } else if (data.body.code == resultCode.NotSuccess) {
                            this.$alert(getErrorMessage(data.body.message));
                        }
                    });
            }
        }
    }
};
</script>